
export const persTestMok = {
    quiz: {
        gamesByMonth: {
            "2018/Dec 14": {date: "2018/Dec 14", total: 1, unique: 1, registrations: 0},

        },
        totalGames: 0,
        totalRegistrations: 0,
        totalUniquePlayers: 0
    },
    calendar: {
        gamesByMonth: {
            "2018/Dec 14": {date: "2018/Dec 14", total: 1, unique: 1, registrations: 0},

        },
        totalGames: 0,
        totalRegistrations: 0,
        totalUniquePlayers: 0
    },
    academy: {
        gamesByMonth: {
            "2018/Dec 14": {date: "2018/Dec 14", total: 1, unique: 1, registrations: 0},

        },
        totalGames: 0,
        totalRegistrations: 0,
        totalUniquePlayers: 0
    },
    person: {
        gamesByMonth: {
            "2018/Dec 14": {date: "2018/Dec 14", total: 1, unique: 1, registrations: 0},

        },
        totalGames: 0,
        totalRegistrations: 0,
        totalUniquePlayers: 0
    },
}
